export const parseLensValueString = (value) => {
  value = value + "";

  if (value === "") return NaN;

  const numberString = value?.replace(",", ".");

  return Number(numberString);
};

export const formatLensValueNumber = (value) => {
  let formattedValue = value.toFixed(2);

  if (value >= 0) {
    formattedValue = `+${formattedValue}`;
  }

  return formattedValue.replace(".", ",");
};
